import React from 'react';
import { Card } from 'react-bootstrap';

/**
 * A reusable container for all module pages.
 * It provides a consistent Card-based layout with a header, body, and an optional footer.
 * @param {object} props - The component props.
 * @param {string} props.title - The title to be displayed in the card header.
 * @param {React.ReactNode} props.children - The main content to be displayed in the card body.
 * @param {React.ReactNode} [props.footer] - Optional content to be displayed in the card footer.
 */
const PageContainer = ({ title, children, footer = null }) => {
    return (
        <Card className="page-card h-100">
            {title && (
                <Card.Header as="h2" className="mb-0">
                    {title}
                </Card.Header>
            )}
            <Card.Body>
                {children}
            </Card.Body>
            {footer && (
                <Card.Footer className="text-end">
                    {footer}
                </Card.Footer>
            )}
        </Card>
    );
};

export default PageContainer;